import { Skeleton } from "@/components/ui/skeleton";

const AddToCartSkeleton = () => {
  return (
    <div className="flex flex-col items-center w-full">
      <Skeleton className="w-full lg:max-w-[300px] h-[50px] rounded-10" />
      <div className="w-[500px] p-5 mt-5 rounded-20 border border-gray5 bg-white">
        <Skeleton className="w-[80%] h-[20px] mb-3" />
        <Skeleton className="w-[60%] h-[16px] mb-5" />
        <div className="space-y-4">
          {[...Array(3)].map((_, index) => (
            <div
              key={index}
              className="flex items-center justify-between py-2"
            >
              <Skeleton className="w-[20px] h-[20px] rounded-sm" />
              <Skeleton className="w-[160px] h-[16px]" />
              <Skeleton className="w-[30px] h-[16px]" />
            </div>
          ))}
        </div>
        <Skeleton className="w-full h-[50px] rounded-10 mt-5" />
      </div>
    </div>
  );
};

export default AddToCartSkeleton;